import api from '../api';
import {store} from '../store';
import _ from 'lodash';

let apiUrl = 'cart';

const state = {
    data: {},
    meta: {}
};

const actions = {
    getCart: async ({commit}, config) => {
        if (!window.meta.cart) {
            return api
                .post(`/${apiUrl}`)
                .then((response) => {
                    window.meta.cart = true;

                })
                .catch((error) => {
                    console.error(error);
                    return Promise.reject(error);
                });
        }
    },
    index: async ({commit, dispatch}, config) => {
        await dispatch('getCart');

        return api
            .get(`/api/v1/${apiUrl}`, config)
            .then((response) => {
                commit('set', response.data);

                return response.data;
            })
            .catch((error) => {
                console.error(error);
                return Promise.reject(error);
            });
    },
    show: async ({commit, dispatch}, id) => {
        await dispatch('getCart');

        return api
            .get(`/api/v1/${apiUrl}/${id}`)
            .then((response) => {
                commit('set', response.data);

                return response.data;
            })
            .catch((error) => {
                console.error(error);
                return Promise.reject(error);
            });
    },
    store: async ({commit, dispatch}, data) => {
        await dispatch('getCart');

        return api
            .post(`/api/v1/${apiUrl}/${data.id}`, data)
            .then((response) => {
                commit('set', response.data);

                return response.data;
            })
            .catch((error) => {
                console.error(error);
                return Promise.reject(error);
            });
    },
    update: async ({commit, dispatch}, data) => {
        await dispatch('getCart');

        return api
            .put(`/api/v1/${apiUrl}/${data.id}`, data)
            .then((response) => {
                commit('set', response.data);

                return response.data;
            })
            .catch((error) => {
                console.error(error);
                return Promise.reject(error);
            });
    },
    delete: async ({commit, dispatch}, data) => {
        await dispatch('getCart');

        return api
            .put(`/api/v1/${apiUrl}/${data.id}`, data)
            .then((response) => {
                commit('set', response.data);

                return response.data;
            })
            .catch((error) => {
                console.error(error);
                return Promise.reject(error);
            });
    },
    autoCoupon: async ({commit, dispatch}, data) => {
        return api
            .get(`/api/v1/${apiUrl}/auto-coupon`, data)
            .then((response) => {
                return response.data == ('' || null || undefined) ? null : response.data;
            })
            .catch((error) => {
                console.error(error);
                return Promise.reject(error);
            });
    }
};

const mutations = {
    set(state, data) {
        state.data = data.data;
        state.meta = data.meta;
    },
    clear(state, data) {
        state.data = {};
        state.meta = {};
        store.commit('cart_products/clear');
    }
};

const getters = {
    all: (state) => {
        return state.data;
    },
    get: (state) => {
        return state.data;
    },
    getById: (state) => (id) => {
        return state.data.find((item) => item.id === id);
    },
    getItems: (state) => {
        if (state.data && state.data.cartProducts) {
            return state.data.cartProducts.data;
        }
    },
    getCount: (state) => {
        if (state.data && state.data.cartProducts) {
            return _.size(state.data.cartProducts.data);
        }

        return 0;
    },
    getMeta: (state) => {
        return state.meta;
    },
    getCouponCode: (state) => {
        return state.data?.coupon_code;
    }
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
};
